import nigeria from "naija-state-local-government";

const stateOptions = [
  { value: "Outside Nigeria", name: "Outside Nigeria" },
  ...nigeria.states(),
];

// console.log("stateOptions", stateOptions);

const yearOptions = () => {
  let currentYear = new Date().getFullYear();
  let years = [];
  let duration = 30;
  let startFrom = 15;
  for (let i = 0; i < duration; i++) {
    years.push({
      value: `${currentYear - startFrom + i}`,
      name: `${currentYear - startFrom + i}`,
    });
  }

  return years;
};
// export const countryList = [
//   { value: "Outside Nigeria", name: "Outside Nigeria" },
//   { value: "Afghanistan", name: "Afghanistan" },
//   { value: "Albania", name: "Albania" },
//   { value: "Algeria", name: "Algeria" },
//   { value: "American Samoa", name: "American Samoa" },
//   { value: "Andorra", name: "Andorra" },
//   { value: "Angola", name: "Angola" },
//   { value: "Anguilla", name: "Anguilla" },
//   { value: "Antarctica", name: "Antarctica" },
//   { value: "Antigua and Barbuda", name: "Antigua and Barbuda" },
//   { value: "Argentina", name: "Argentina" },
//   { value: "Armenia", name: "Armenia" },
//   { value: "Aruba", name: "Aruba" },
//   { value: "Australia", name: "Australia" },
//   { value: "Austria", name: "Austria" },
//   { value: "Azerbaijan", name: "Azerbaijan" },
//   { value: "Bahamas", name: "Bahamas" },
//   { value: "Bahrain", name: "Bahrain" },
//   { value: "Bangladesh", name: "Bangladesh" },
//   { value: "Barbados", name: "Barbados" },
//   { value: "Belarus", name: "Belarus" },
//   { value: "Belgium", name: "Belgium" },
//   { value: "Belize", name: "Belize" },
//   { value: "Benin", name: "Benin" },
//   { value: "Bermuda", name: "Bermuda" },
//   { value: "Bhutan", name: "Bhutan" },
//   { value: "Bolivia", name: "Bolivia" },
//   { value: "Bonaire", name: "Bonaire" },
//   { value: "Bosnia and Herzegovina", name: "Bosnia and Herzegovina" },
//   { value: "Botswana", name: "Botswana" },
//   { value: "Bouvet Island", name: "Botswana" },
//   { value: "Brazil", name: "Botswana" },
//   { value: "Brunei Darussalam", name: "Botswana" },
//   { value: "Bulgaria", name: "Botswana" },
//   { value: "Burkina Faso", name: "Botswana" },
//   { value: "Burundi", name: "Botswana" },
//   { value: "Cabo Verde", name: "Botswana" },
//   { value: "Cambodia", name: "Botswana" },
//   { value: "Cameroon", name: "Botswana" },
//   { value: "Canada", name: "Botswana" },
//   { value: "Cayman Islands", name: "Cayman Islands" },
//   { value: "Central African Republic", name: "Central African Republic" },
//   { value: "Chad", name: "Botswana" },
//   { value: "Chile", name: "Botswana" },
//   { value: "China", name: "Botswana" },
//   { value: "Christmas Island", name: "Botswana" },
//   { value: "Cocos", name: "Botswana" },
//   { value: "Colombia", name: "Botswana" },
//   { value: "Comoros", name: "Botswana" },
//   { value: "Congo", name: "Botswana" },
//   { value: "Congo", name: "Botswana" },
//   { value: "Cook Islands", name: "Botswana" },
//   { value: "Costa Rica", name: "Botswana" },
//   { value: "Croatia", name: "Botswana" },
//   { value: "Cuba", name: "Botswana" },
//   { value: "Curaçao", name: "Botswana" },
//   { value: "Cyprus", name: "Botswana" },
//   { value: "Czechia", name: "Botswana" },
//   { value: "Côte d'Ivoire", name: "Botswana" },
//   { value: "Denmark", name: "Botswana" },
//   { value: "Djibouti", name: "Botswana" },
//   { value: "Dominica", name: "Botswana" },
//   { value: "Dominican Republic", name: "Botswana" },
//   { value: "Ecuador", name: "Botswana" },
//   { value: "Egypt", name: "Botswana" },
//   { value: "El Salvador", name: "Botswana" },
//   { value: "Equatorial Guinea", name: "Botswana" },
//   { value: "Eritrea", name: "Botswana" },
//   { value: "Estonia", name: "Botswana" },
//   { value: "Eswatini", name: "Botswana" },
//   { value: "Ethiopia", name: "Botswana" },
//   { value: "Falkland Islands", name: "Botswana" },
//   { value: "Faroe Islands", name: "Botswana" },
//   { value: "Fiji", name: "Botswana" },
//   { value: "Finland", name: "Botswana" },
//   { value: "France", name: "Botswana" },
//   { value: "Gabon", name: "Botswana" },
//   { value: "Gambia", name: "Botswana" },
//   { value: "Georgia", name: "Botswana" },
//   { value: "Germany", name: "Botswana" },
//   { value: "Ghana", name: "Botswana" },
//   { value: "Gibraltar", name: "Botswana" },
//   { value: "Greece", name: "Botswana" },
//   { value: "Greenland", name: "Botswana" },
//   { value: "Grenada", name: "Botswana" },
//   { value: "Guadeloupe", name: "Botswana" },
//   { value: "Guam", name: "Botswana" },
//   // { value: "Guatemala"},
//   // { value: "Guernsey"},
//   // { value: "Guinea"},
//   // { value: "Guinea-Bissau"},
//   // { value: "Guyana"},
//   // { value: "Haiti"},
//   // { value: "Heard Island"},
//   // { value: "Holy See"},
//   // { value: "Honduras"},
//   // { value: "Hong Kong"},
//   // { value: "Hungary"},
//   // { value: "Iceland"},
//   // { value: "India"},
//   // { value: "Indonesia"},
//   // { value: "Iran"},
//   // { value: "Iraq"},
//   // { value: "Ireland"},
//   // { value: "Isle of Man"},
//   // { value: "Israel"},
//   // { value: "Italy"},
//   // { value: "Jamaica"},
//   // { value: "Japan"},
//   // { value: "Jersey"},
//   // { value: "Jordan"},
//   // { value: "Kazakhstan"},
//   // { value: "Kenya"},
//   // { value: "Kiribati"},
//   // { value: "Korea "},
//   // { value: "Kuwait"},
//   // { value: "Kyrgyzstan"},
//   { value: "Democratic Republic", name: "Democratic Republic" },
//   { value: "Latvia", name: "Latvia" },
//   { value: "Lebanon", name: "Lebanon" },
//   { value: "Lesotho", name: "Lesotho" },
//   { value: "Liberia", name: "Liberia" },
//   { value: "Libya", name: "Libya" },
//   { value: "Liechtenstein", name: "Liechtenstein" },
//   { value: "Lithuania", name: "Lithuania" },
//   { value: "Luxembourg", name: "Luxembourg" },
//   { value: "Macao", name: "Macao" },
//   { value: "Madagascar", name: "Madagascar" },
//   { value: "Malawi", name: "Malawi" },
//   { value: "Malaysia", name: "Malaysia" },
//   { value: "Maldives", name: "Maldives" },
//   { value: "Mali", name: "Mali" },
//   { value: "Malta" },
//   // { value: "Marshall Islands"},
//   // { value: "Martinique"},
//   // { value: "Mauritania"},
//   // { value: "Mauritius"},
//   // { value: "Mayotte"},
//   // { value: "Mexico"},
//   // { value: "Micronesia"},
//   // { value: "Moldova"},
//   // { value: "Monaco"},
//   // { value: "Mongolia"},
//   // { value: "Montenegro"},
//   // { value: "Montserrat"},
//   // { value: "Morocco"},
//   // { value: "Mozambique"},
//   // { value: "Myanmar"},
//   // { value: "Namibia"},
//   // { value: "Nauru"},
//   { value: "Nepal", name: "Nepal" },
//   { value: "Netherlands", name: "Netherlands" },
//   { value: "New Caledonia", name: "New Caledonia" },
//   { value: "New Zealand", name: "New Zealand" },
//   { value: "Nicaragua", name: "Nicaragua" },
//   { value: "Niger", name: "Niger" },
//   { value: "Nigeria", name: "Nigeria" },
//   { value: "Niue", name: "Niue" },
//   { value: "Norfolk Island", name: "Norfolk Island" },
//   { value: "Northern Mariana Islands", name: "Northern Mariana Islands" },
//   { value: "Norway", name: "Norway" },
//   { value: "Oman", name: "Oman" },
//   { value: "Pakistan", name: "Pakistan" },
//   { value: "Palau", name: "Palau" },
//   { value: "Palestine", name: "Palestine" },
//   { value: "Panama", name: "Panama" },
//   { value: "New Guinea", name: "New Guinea" },
//   { value: "Paraguay", name: "Paraguay" },
//   { value: "Peru", name: "Peru" },
//   { value: "Philippines", name: "Philippines" },
//   { value: "Pitcairn", name: "Pitcairn" },
//   { value: "Poland", name: "Pitcairn" },
//   { value: "Portugal", name: "Pitcairn" },
//   { value: "Puerto Rico", name: "Pitcairn" },
//   { value: "Qatar", name: "Pitcairn" },
//   { value: "Republic of North Macedonia", name: "Pitcairn" },
//   { value: "Romania", name: "Pitcairn" },
//   { value: "Russian Federation", name: "Pitcairn" },
//   { value: "Rwanda", name: "Pitcairn" },
//   { value: "Réunion", name: "Pitcairn" },
//   { value: "Saint Barthélemy", name: "Pitcairn" },
//   { value: "Samoa", name: "Pitcairn" },
//   { value: "San Marino", name: "Pitcairn" },
//   { value: "Sao Tome and Principe", name: "Pitcairn" },
//   { value: "Saudi Arabia", name: "Pitcairn" },
//   { value: "Senegal", name: "Senegal" },
//   { value: "Serbia", name: "Senegal" },
//   { value: "Seychelles", name: "Senegal" },
//   { value: "Sierra Leone", name: "Senegal" },
//   { value: "Singapore", name: "Senegal" },
//   { value: "Sint Maarten", name: "Senegal" },
//   { value: "Slovakia", name: "Senegal" },
//   { value: "Slovenia", name: "Senegal" },
//   // { value: "Solomon Islands"},
//   // { value: "Somalia"},
//   // { value: "South Africa"},
//   // { value: "South Sudan"},
//   // { value: "Spain"},
//   // { value: "Sri Lanka"},
//   // { value: "Sudan (the)"},
//   // { value: "Suriname"},
//   // { value: "Svalbard"},
//   // { value: "Sweden"},
//   // { value: "Switzerland"},
//   // { value: "Syrian"},
//   // { value: "Taiwan"},
//   // { value: "Tajikistan"},
//   // { value: "Tanzania"},
//   // { value: "Thailand"},
//   // { value: "Timor-Leste"},
//   // { value: "Togo"},
//   // { value: "Tokelau"},
//   // { value: "Tonga"},
//   // { value: "Trinidad"},
//   // { value: "Tunisia"},
//   // { value: "Turkey"},
//   // { value: "Turkmenistan"},
//   // { value: "Turks"},
//   // { value: "Tuvalu"},
//   // { value: "Uganda"},
//   // { value: "Ukraine"},
//   // { value: "United Arab Emirates"},
//   // { value: "United Kingdom"},
//   // { value: "United States"},
//   // { value: "Uruguay"},
//   // { value: "Uzbekistan"},
//   // { value: "Vanuatu"},
//   // { value: "Venezuela"},
//   // { value: "Viet Nam"},
//   // { value: "Western Sahara"},
//   // { value: "Yemen"},
//   // { value: "Zambia"},
//   // { value: "Zimbabwe"},
//   // { value: "Åland Islands"}
// ];

const countryList = [
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas (the)",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory (the)",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands (the)",
  "Central African Republic (the)",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands (the)",
  "Colombia",
  "Comoros (the)",
  "Congo (the Democratic Republic of the)",
  "Congo (the)",
  "Cook Islands (the)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic (the)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (the) [Malvinas]",
  "Faroe Islands (the)",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories (the)",
  "Gabon",
  "Gambia (the)",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (the)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (the Democratic People's Republic of)",
  "Korea (the Republic of)",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic (the)",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands (the)",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia (Federated States of)",
  "Moldova (the Republic of)",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands (the)",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger (the)",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands (the)",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines (the)",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of North Macedonia",
  "Romania",
  "Russian Federation (the)",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan (the)",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan (Province of China)",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands (the)",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates (the)",
  "United Kingdom of Great Britain and Northern Ireland (the)",
  "United States Minor Outlying Islands (the)",
  "United States of America (the)",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela (Bolivarian Republic of)",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export { stateOptions, yearOptions, countryList };
